<template>
  <div class="account-login">
    <div class="ipt-group" :class="{ error: $v.form.account.$error }">
      <input type="text" v-model.trim="form.account" autocomplete="off" />
      <p class="sub-text" :class="{ 'has-text': form.account }" @click="focusInput">
        考试账号
      </p>
      <div class="line" :style="'background:' + $store.state.theme.themeColor"></div>
      <vd-tips path="form.account" class="error-tip" />
    </div>
    <div class="ipt-group mb60" :class="{ error: $v.form.password.$error }">
      <input type="password" autocomplete="new-password" v-model.trim="form.password" />
      <p class="sub-text" :class="{ 'has-text': form.password }" @click="focusInput">
        密码
      </p>
      <div class="line" :style="'background:' + $store.state.theme.themeColor"></div>
      <vd-tips path="form.password" class="error-tip" />
    </div>
    <countdown-btn el="button" type="submit" class="login-btn"
      :style="'background:' + theme.buttonBackground + 'box-shadow: ' + theme.buttonShadow" placeholder="登录"
      lockTmp="登录中..." clickTips="请稍后" @click="onCaptcha"></countdown-btn>
  </div>
</template>

<script>
import { required, validationMixin } from '@/utils/mixin_validate'
import CountdownBtn from '@/components/CountdownBtn'

export default {
  name: 'AccountLogin',
  components: {
    CountdownBtn
  },
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        account: {
          required
        },
        password: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      account: {
        required: '请输入账号'
      },
      password: {
        required: '请输入密码'
      }
    }
  },
  data() {
    return {
      form: {
        account: '',
        password: ''
      }
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    },
    // 是否是山东科协
    isShandongKexie() {
      return window.location.href.indexOf(CONFIG.shandongkexie) !== -1
    }
  },
  methods: {
    focusInput(e) {
      e.target.previousSibling.focus()
    },
    // 图形化验证
    async onCaptcha(lock, reset) {
      try {
        await this.validationTouch()
        lock()
        const identity = `${this.isShandongKexie ? 'K' : ''}${this.form.account.trim()}`
        // 弹出验证码
        this.$verify({
          identity: identity,
          scene: 'login',
          dom_id: 'countdownBtn',
          success_callback: (ticket) => this.login(ticket, reset),
          fail_callback: reset,
          close_callback: reset
        })
      } catch (e) {
        reset()
      }
    },
    // 账号登录，成功获取通用图形验证码ticket，登录
    async login(ticket, reset) {
      try {
        const { account, password } = this.form
        const username = `${this.isShandongKexie ? 'K' : ''}${account.trim()}`
        await this.$auth('login_account_ticket', ...[username, password, 'egLIJPgY', ticket])
        localStorage.setItem('currentAccount', username)
        this.$emit('success')
        reset()
      } catch (e) {
        this.$emit('fail', e)
        reset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-login {
  ::v-deep {
    @import "./index.scss";
  }
}
</style>
